import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#sobre", label: "El barco" },
  { href: "#experiencias", label: "Experiencias" },
  { href: "#galeria", label: "Galería" },
  { href: "#portonovo", label: "Portonovo" },
  { href: "#por-que", label: "Por qué Zorba" },
  { href: "#prensa", label: "Prensa" },
  { href: "#contacto", label: "Contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/85 backdrop-blur-md border-b border-border/60" : "bg-transparent"
      }`}
    >
      <div className="container-tight flex items-center justify-between py-4">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2">
          <span className={`font-heading text-2xl tracking-tight ${scrolled ? "text-navy" : "text-white"}`}>
            Zorba
          </span>
          <span className={`label-eyebrow hidden sm:inline ${scrolled ? "text-navy/60" : "text-white/70"}`}>
            · Velero clásico
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className={`text-sm font-medium transition-colors ${
                scrolled ? "text-navy/80 hover:text-navy" : "text-white/85 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://wa.me/34649927028"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="btn-pill bg-navy text-white px-5 py-2 text-sm font-medium hover:bg-[#142949]"
          >
            WhatsApp
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className={`md:hidden p-2 rounded-md ${scrolled ? "text-navy" : "text-white"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background border-t border-border" data-testid="mobile-menu">
          <div className="container-tight py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-navy/80 py-2 text-base"
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="https://wa.me/34649927028"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-whatsapp-btn"
              className="btn-pill bg-navy text-white px-5 py-3 text-sm font-medium text-center"
            >
              Escríbenos por WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
